import {useEffect, useState, ChangeEvent} from 'react';

import Checkbox from '@mui/joy/Checkbox';
import List from '@mui/joy/List';
import ListItem from '@mui/joy/ListItem';

export const UiChip = (props: {
    options: uiChipOption[],
    onClick: (name: string, value: boolean) => void,
    disabled?: boolean,
}) => {
    const [selected, setSelected] = useState<uiChipOption[]>(props.options);

    useEffect(() => {
        setSelected(props.options);
    }, [props.options.length]);

    return (
        <List
            className={cmpClass}
            orientation="horizontal"
            wrap
            sx={{
                '--List-gap': '8px',
                '--ListItem-radius': '20px',
                '--ListItem-minHeight': '32px',
                '--ListItem-gap': '4px',
                'userSelect': 'none',
            }}
        >
            {
                selected.map(
                    (option) => (
                        <ListItem
                            key={option.name}
                            sx={{width: '98.5%', justifyContent: 'center', boxSizing: 'border-box'}}
                        >
                            {option.checked && (
                                <i
                                    className={'iconfas-success'}
                                    style={{zIndex: 2}}
                                ></i>
                            )}
                            <Checkbox
                                size="sm"
                                disableIcon
                                overlay
                                label={option.label}
                                checked={option.checked}
                                variant={option.checked ? 'soft' : 'outlined'}
                                onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                    const newOption = {
                                        ...option,
                                        checked: event.target.checked,
                                    };

                                    props.onClick(newOption.name, newOption.checked);

                                    setSelected(selected.map((currentOption) => {
                                        return newOption.name === currentOption.name ? {...newOption} : {...currentOption};
                                    }));
                                }}
                                disabled={props.disabled}
                                slotProps={{
                                    action: ({checked}) => ({
                                        sx: checked ?
                                            {
                                                border: '1px solid',
                                                borderColor: 'primary.500',
                                            } :
                                            {},
                                    }),
                                }}
                            />
                        </ListItem>
                    ),
                )
            }
        </List>
    );
};

const cmpClass = 'ui-chip';
